import { useState } from "react";
import { getSupabaseClient } from "@veorest/api-client";
import { useI18n } from "../i18n";
import { useBackendReachable } from "@veorest/pwa";

export default function LoginPage() {
  const { t } = useI18n();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const reachable = useBackendReachable();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim() || !password) return;

    if (!reachable) {
      setError("Internet connection required to login. Please check your connection and try again.");
      return;
    }

    setBusy(true);
    setError("");
    try {
      const supabase = getSupabaseClient();
      const { error: err } = await supabase.auth.signInWithPassword({
        email: email.trim(),
        password,
      });
      if (err) throw err;
      window.location.href = "/pos";
    } catch (err) {
      setError(err instanceof Error ? err.message : "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={{
      minHeight: "100dvh", display: "flex", alignItems: "center", justifyContent: "center",
      background: "#0a0a0b", padding: 20,
    }}>
      <form onSubmit={handleLogin} style={{
        width: "100%", maxWidth: 380, display: "flex", flexDirection: "column", gap: 16,
      }}>
        <div style={{ textAlign: "center", marginBottom: 8 }}>
          <div style={{
            width: 56, height: 56, borderRadius: 16, background: "var(--accent)",
            display: "flex", alignItems: "center", justifyContent: "center",
            margin: "0 auto 12px", fontWeight: 900, fontSize: 22, color: "#fff",
          }}>O</div>
          <h1 style={{ color: "#fff", fontSize: 20, fontWeight: 800, margin: 0 }}>{t("auth.title")}</h1>
          <p style={{ color: "#94a3b8", fontSize: 13, margin: "4px 0 0" }}>{t("auth.subtitle")}</p>
        </div>

        {error && (
          <div style={{
            padding: "10px 14px", borderRadius: 10, background: "rgba(220,38,38,0.15)",
            color: "#fca5a5", fontSize: 13, fontWeight: 600,
          }}>{error}</div>
        )}

        <input
          type="email"
          placeholder={t("auth.email")}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          autoFocus
          autoComplete="email"
          style={{
            padding: "12px 14px", borderRadius: 10,
            background: "#1a1a1f", border: "1px solid #2a2a30",
            color: "#fff", fontSize: 14, outline: "none",
          }}
        />
        <input
          type="password"
          placeholder={t("auth.password")}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoComplete="current-password"
          style={{
            padding: "12px 14px", borderRadius: 10,
            background: "#1a1a1f", border: "1px solid #2a2a30",
            color: "#fff", fontSize: 14, outline: "none",
          }}
        />
        <button
          type="submit"
          disabled={busy}
          style={{
            padding: "13px", borderRadius: 10, border: "none",
            background: busy ? "#4a4a55" : "var(--accent)",
            color: "#fff", fontWeight: 800, fontSize: 15, cursor: busy ? "not-allowed" : "pointer",
          }}
        >
          {busy ? t("auth.signingIn") : t("auth.signIn")}
        </button>
      </form>
    </div>
  );
}
